import { useToken as useMsToken } from '../util/msal'
import { paymentService, useGatedQuery } from './config'

export const Permission = {
  SUBMERCHANTS_READ: 'submerchants:read',
  SUBMERCHANTS_CREATE: 'submerchants:create',
  SUBMERCHANTS_UPDATE: 'submerchants:update',

  MONTHLY_BILLING_READ: 'monthly_billing:read',
  MONTHLY_BILLING_EXPORT: 'monthly_billing:export',
  MONTHLY_BILLING_UPDATE: 'monthly_billing:update',

  SHARE_RULES_READ: 'share_rules:read',
  SHARE_RULES_CREATE: 'share_rules:create',
  SHARE_RULES_UPDATE: 'share_rules:update',
  SHARE_RULES_DELETE: 'share_rules:delete',

  VOUCHER_CODES_READ: 'voucher_codes:read',
  VOUCHER_CODES_CREATE: 'voucher_codes:create',
  VOUCHER_CODES_UPDATE: 'voucher_codes:update'
} as const

export type PermissionValue = (typeof Permission)[keyof typeof Permission]

export interface PermissionsResponse {
  roles: string[]
  permissions: PermissionValue[]
}

const getPermissions = async (token: string): Promise<PermissionsResponse> => {
  if (!token) {
    return { roles: [], permissions: [] }
  }

  return (await paymentService('v1/internal/me/permissions', token)
    .get()
    .json()) as PermissionsResponse
}

export function usePermissions() {
  const token = useMsToken()

  return useGatedQuery({
    queryKey: ['me-permissions'],
    queryFn: () => getPermissions(token),
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry(attempts, error) {
      const status = (error as { status?: number })?.status
      return status !== 401 && status !== 403 && attempts < 2
    }
  })
}
